<mat-card>

  <div class="searchTab">
      
    <!-- For Next Phase -->
    <!-- <div class="tabBar">
          <div class="bar active">
              <span><mat-icon>chat_bubble_outline</mat-icon></span>
              Chat
          </div>
          <div class="bar">
              <span><mat-icon>alternate_email</mat-icon></span>
              Mentions
          </div>
          <div class="bar">
              <span><mat-icon>bookmark</mat-icon></span>
              Bookmark
          </div>
          <div class="bar">
              <span><mat-icon>star_rate</mat-icon></span>
              Favorites
          </div>
      </div> -->
      <div class="searchBar">
          <div class="search">          
              <input type="text" placeholder="Search contact or message" (input)="SearchChatOrMessages()" [(ngModel)]="searchTerm" >
              <button mat-icon-button (click)="SearchChatOrMessages()"><mat-icon>search</mat-icon></button>
          </div>
          <div class="menu">
              <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>add</mat-icon></button>
              <mat-menu #menu="matMenu" xPosition="before">
                  <button mat-menu-item (click)="startNewChat(newChat)"><mat-icon>chat_bubble_outline</mat-icon> New Chat</button>
                  <button mat-menu-item (click)="startNewGroup(newGroup)"><mat-icon>group</mat-icon> New Group</button>
              </mat-menu>
          </div>
      </div>
  </div>
  
  
  
  <div class="userHolder">
      <div class="userCard" [ngClass]="{ 'active': chatId === user.id }" *ngFor="let user of users">
          <div class="userPic"  *ngIf="user.imageUrl" (click)="chatDetails(user)">
            <img [src]="user.imageUrl" alt="" />  
           <!-- <span>{{getShortName(user.roomName)}}</span> -->
              <!-- <span class="status online" *ngIf="user.status == 'online'"></span>
              <span class="status offline" *ngIf="user.status == 'offline'"></span>
              <span class="status away" *ngIf="user.status == 'away'"></span>
              <span class="status do-not-disturb" *ngIf="user.status == 'do-not-disturb'"></span> -->
          </div>

          <div class="userPic"  *ngIf="!user.imageUrl" (click)="chatDetails(user)">           
              <span>{{getShortName(user.roomName)}}</span>          
           </div>

          <div class="UserInfo" (click)="chatDetails(user)">
            <h3>{{user.roomName}}</h3>
           <p>{{user.recentMessage}}</p>             
           <div class="messageAlert" [ngClass]="{'activeGrp': user.unReadMessages>0}" ><mat-icon>sms</mat-icon></div>    
          </div>         

          <div class="lastTime" *ngIf="(user.updatedOn | date:'MM/dd/yyyy') === (currentDate | date:'MM/dd/yyyy') ">
              {{user.updatedOn | date:'h:mm a'}}
          </div>
          <div class="lastTime" *ngIf="(user.updatedOn | date:'MM/dd/yyyy') !== (currentDate | date:'MM/dd/yyyy') ">
            {{user.updatedOn | date:'MM/dd/yyyy'}}
        </div>
      </div>
  </div>
  
  </mat-card>
  
  <ng-template #newChat>
      <h2 mat-dialog-title>
         <span class="groupIcon"><mat-icon>chat_bubble_outline</mat-icon></span>
          New Chat        
            <button mat-icon-button (click)="close()"> <mat-icon>close</mat-icon> </button>
          </h2>
      
    <mat-dialog-content class="mat-typography">
  
    
      <div class="searchUser">
        <mat-form-field appearance="fill">
          <mat-label>Search User</mat-label>
          <input matInput type="text" maxlength="20"
          (input)="SetSearchValue($event.target.value)"> 
          <!-- <input matInput type="text"
          (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)"> -->
  
        </mat-form-field>
        <!-- <button [disabled]="isEnabled" mat-button (click)="Search()">Search</button> -->
        <button [disabled]="!isEnabled" mat-fab color="primary" (click)="SearchEmail()"><mat-icon>search</mat-icon><mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon></button>


      </div>




      <ul class="selectedlist">
        
        <li *ngFor="let user of peoples">
          <div class="userndetail" (click)='CreateNewChat(user)'>
              <div class="pic" *ngIf="user.profileImagePath">
                <img [src]="user.profileImagePath" alt="" />  
              </div>
              <div class="pic" *ngIf="!user.profileImagePath">
                <span>{{getShortNameEmail(user.email)}}</span>
              </div>
              <div class="detail">
                  <h4>{{user.email}}</h4>
                  <!-- <p>{{user.email}}</p> -->
              </div>
          </div>       
        </li>
       
      </ul>
    
      
    </mat-dialog-content>
    
  </ng-template>
  
  
  <ng-template #newGroup>
      <h2 mat-dialog-title>
         <span class="groupIcon"><mat-icon>chat_bubble_outline</mat-icon></span>
          New Group Chat        
            <button mat-icon-button (click)="close()"> <mat-icon>close</mat-icon> </button>
          </h2>
      
    <mat-dialog-content class="mat-typography">
  
      <mat-form-field appearance="outline">
          <mat-label>Group Name</mat-label>
          <input matInput placeholder="Add Group Name" maxlength="50" 
          [(ngModel)]="groupName" (input)="onChange($event.target.value)"  required>
        </mat-form-field>


        <ng-container *ngIf="selectedUser">
          <div  class="selecList" >
            <ng-container *ngFor="let use of selectedUser">
              <div class="selec">
                {{use.userName}} <span (click)='SelectUser(use)' ><mat-icon>close</mat-icon></span>
              </div>
            </ng-container>
          </div>
        </ng-container>
      
    
<div class="searchUser">
  <mat-form-field appearance="fill">
    <mat-label>Search User</mat-label>
    <input matInput type="text" maxlength="20"
    (input)="SetSearchValue($event.target.value)"> 
  </mat-form-field>
  <button [disabled]="!isEnabled" mat-fab  color="primary" (click)="SearchEmail()"><mat-icon>search</mat-icon><mat-icon *ngIf="spinner"><mat-spinner diameter="20">
  </mat-spinner></mat-icon></button>
</div>

      <ul class="selectedlist">
        
        <li *ngFor="let user of peoples">
          <div class="userndetail" (click)='SelectUserFromCheckBox($event,user)'>
              <div class="pic" *ngIf="user.profileImagePath">
                <img [src]="user.profileImagePath" alt="" />  
              </div>
              <div class="pic" *ngIf="!user.profileImagePath">
                <span>{{getShortNameEmail(user.email)}}</span>
              </div>
              <div class="detail">
                  <h4>{{user.email}}</h4>
                  <!-- <p>{{user.email}}</p> -->
              </div>
          </div>
          <div class="option">
              <mat-checkbox color="primary" [ngModel]="user.isChecked"
               (change)='SelectUserFromCheckBox($event,user)'></mat-checkbox>
          </div>
        </li>
       
      </ul>
    
      
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="!DoneButtonShow"
      (click)="CreateNewGroup()">Done</button>
    </mat-dialog-actions>
  </ng-template>

  <div class="progress-loader" *ngIf="spinner">
    <div class="lds-ripple" ><div></div><div></div></div>
  </div>
  
  